import { get } from 'lodash'

import { Services, joinURLPath } from '@sigma-frontend-libs/commons'
import { Macro } from '@sigma-legacy-libs/cache'
import { isUUID } from '@sigmasms/commons'

import { globalErrorHandler, macroCacheOptions, request } from '@/utils'

import render from './render'

const Cache = new Macro(macroCacheOptions)
const cachedGet = Cache.wrapWithCache(async (key, id) => {
  return await request.get(joinURLPath(Services.contactLists, id))
})

export default {
  name: 'TasksAnalytics',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      analytics: {},

      showDialog: false,
      loading: false
    }
  },

  methods: {
    async analysis() {
      try {
        this.loading = true
        this.clearAnalytics()

        const data = get(this.value, 'data.recipients', {})
        for (const type of [ 'include', 'exclude' ]) {
          const { lists, recipients } = data[type] || {}
          if (Array.isArray(lists) && lists.length) {
            this.analytics[type] = []
            await Promise.all(
              lists.map(async id => {
                if (isUUID(id)) {
                  const data = await cachedGet(`${Services.contactLists}:${id}`, id)
                  if (data) {
                    this.analytics[type].push({
                      title: data.title,
                      id
                    })
                  }
                }
              })
            )
          }
          if (Array.isArray(recipients) && recipients.length) {
            for (const item of recipients) {
              this.analytics[type].push({ title: item })
            }
          }
        }

        const errors = get(this.value, 'meta.errors.$fatals')
        if (errors) {
          for (const key in errors) {
            this.analytics.error = []
            this.analytics.error.push({
              title: key,
              error: errors[key]
            })
          }
        }

        if (Object.keys(this.analytics).length) {
          this.showDialog = true
        }
      } catch (error) {
        globalErrorHandler(error)
      } finally {
        this.loading = false
      }
    },

    clearAnalytics() {
      this.analytics = {}
    }
  },

  render
}
